<template>
  <div class="api-usage-box outer-page-primary">
    <div class="usage-chart-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">API调用访问汇总折线图</div>
      </div>
      <div
        class="tab-box"
        v-show="!isChartCollapse">
        <div
          :class="getChartTabClassName('api')"
          @click="usageTabClick('api')">
          按接口汇总
        </div>
        <div
          :class="getChartTabClassName('user')"
          @click="usageTabClick('user')">
          按用户汇总
        </div>
      </div>
      <div
        class="echart-box"
        v-show="!isChartCollapse">
        <div class="echarts-bg"></div>
        <div
          id="echart"
          class="echart-content-box" />
      </div>
      <div
        class="collapse-btn-box"
        @click="toggleCollapseChart">
        <div class="icon-box">
          <i
            size="14"
            :class="isChartCollapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            class="el-icon"></i>
        </div>
      </div>
    </div>
    <div class="usage-table-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">API调用列表</div>
      </div>
      <div class="operation-box">
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label-box searchLabel">路由名称：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                clearable
                placeholder="请输入路由名称"
                v-model="routerName" />
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">用户名：</div>
            <div class="common-select-box userLabel">
              <el-select
                class="primary-select"
                size="small"
                remote
                filterable
                clearable
                v-model="userId"
                :loading="loading"
                :remote-method="filterUserList"
                :popper-append-to-body="false"
                placeholder="请输入用户名称"
                @clear="filterUserList(null)"
                @focus="onUserSelectFocus">
                <div
                  class="infinite-scroll-box"
                  v-infinite-scroll="handleUserListScroll">
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="item.surname"
                    :value="item.userId" />
                </div>
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">调用日期：</div>
            <div class="common-datepicker-box">
              <el-date-picker
                class="date-picker-primary"
                v-model="dateValue"
                type="daterange"
                size="mini"
                :clearable="false"
                popper-class="datepicker-popper-box"
                :editable="false"
                :append-to-body="false"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions" />
            </div>
            <div class="time-tab-box">
              <div
                :class="getTimeTabClassName('day')"
                @click="timeTabClick('day')">
                今天
              </div>
              <div
                :class="getTimeTabClassName('week')"
                @click="timeTabClick('week')">
                一周以内
              </div>
              <div
                :class="getTimeTabClassName('month')"
                @click="timeTabClick('month')">
                一月以内
              </div>
            </div>
          </div>
        </div>
        <div class="common-button-box common-button-box-search">
          <el-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="search">
            查询
          </el-button>
          <el-button
            class="normal-btn"
            size="small"
            @click="resetFilter"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table-box">
        <div
          v-if="isTableLoading"
          class="loading-box">
          <Spin
            :pointNum="8"
            :translateX="25"
            background="var(--base-primary-bgColor)" />
        </div>
        <div
          class="common-table-box"
          v-else>
          <el-table
            class="publish-table"
            ref="table"
            highlight-selection-row
            :header-row-class-name="customHeader"
            :data="apiUsageDataList"
            height="100%">
            <el-table-column
              label="序号"
              type="index"
              width="75" />
            <el-table-column
              label="路由名称"
              width="400">
              <template v-slot="{ row }">
                <div
                  class="text-overflow name-column-box"
                  :title="row.url">
                  {{ row.url }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="用户名">
              <template v-slot="{ row }">
                <div
                  class="text-overflow"
                  :title="row.userName">
                  {{ row.userName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="请求方式"
              prop="httpMethod" />
            <el-table-column
              label="客户端IP地址"
              prop="clientIpAddress" />
            <el-table-column
              label="请求发起时间"
              width="180">
              <template v-slot="{ row }">
                <div>
                  {{ row.executionTime ? formatTime(row.executionTime) : '--' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="请求时长(ms)"
              prop="executionDuration" />
            <el-table-column
              label="操作"
             
              width="120">
              <template v-slot="{ row }">
                <div class="common-button-box operation-cell">
                  <el-button
                    @click="viewDetails(row)"
                    type="text"
                    size="small">
                    查看详情
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="common-empty-box">
                <bj-empty
                  :image="require('@/assets/img/no-data.png')"
                  class="empty-page">
                  <template slot="description">没有找到相关内容</template>
                </bj-empty>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div class="common-pagination-box">
        <el-pagination
          class="pagination-primary"
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currPage"
          :total="total"
          @size-change="sizeChange"
          @current-change="pageChange" />
      </div>
    </div>
    <StatisticsDetailDialog
      :visible="isDetailsDialogVisible"
      :apiInfo="apiInfo"
      :closeDialog="closeDetailsDialog" />
  </div>
</template>

<script>
import * as echarts from 'echarts'
import Spin from '@/components/Spin.vue'
import StatisticsDetailDialog from './components/StatisticsDetailDialog.vue'

import { formatTime } from '@/utils/generalMethods'

import {
  getTodayStatisticsByUrlService,
  getTodayStatisticsByUserService,
  getUserNameList,
  getStatisticsListService
} from '@/service/interface'
export default {
  data() {
    return {
      currChartTab: 'api',
      apiUsageData: [],
      echartRef: null,
      isChartCollapse: false,

      routerName: '',
      customHeader: '',
      userId: undefined,
      filterValue: '',
      loading: false,
      allUserLoaded: false,
      userList: [],
      currentPage: 1,
      userListPageSize: 20,

      dateValue: [],
      currTimeTab: 'day',
      pickerOptions: {
        disabledDate: date => {
          let currTime = new Date()
          let todayTime = new Date(currTime.toDateString()).getTime()
          let dateTime = date.getTime()

          return dateTime > todayTime
        },
        onPick: eventInfo => {
          let { maxDate, minDate } = eventInfo
          if (minDate && maxDate) {
            let deltaTime = maxDate.getTime() - minDate.getTime()
            if (deltaTime > 30 * 24 * 60 * 60 * 1000) {
              this.$message.warning('时间跨度不能超过一个月,请重新选择')
              this.$nextTick(() => {
                this.dateValue = []
              })
            }
            this.currTimeTab = ''
          }
        }
      },
      apiUsageDataList: [],

      isTableLoading: false,
      total: 0,
      currPage: 1,
      pageSize: 10,

      isDetailsDialogVisible: false,
      apiInfo: {}
    }
  },
  components: { Spin, StatisticsDetailDialog },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.table.bodyWrapper
      currentBody.addEventListener('scroll', ev => {
        const scrollTop = ev.target.scrollTop
        this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
      })
    }, 500)
    this.init()
  },
  computed: {
    chartsLegendTextColor: function () {
      return this.$theme.get().value === 'stellar-light' ? '#333' : '#ffffff'
    },
    chartsLegendPageIconColor: function () {
      return this.$theme.get().value === 'stellar-light' ? '#d9d9d9' : '#d9d9d9'
    },
    chartsAxisTextColor: function () {
      return this.$theme.get().value === 'stellar-light' ? '#333' : '#ffffff'
    }
  },
  methods: {
    init() {
      this.queryTodayStatistics('api').then(echartOptions => {
        this.initChart(echartOptions)
      })
      this.initUserList()
      this.initDateValue()
      this.initStatisticsList()
    },
    usageTabClick(tabName) {
      this.currChartTab = tabName

      this.queryTodayStatistics(tabName).then(echartOptions => {
        this.initChart(echartOptions)
      })
    },
    getChartTabClassName(tabName) {
      let className = 'tab-item-box'
      if (tabName === this.currChartTab) {
        className += ' active'
      }
      return className
    },
    toggleCollapseChart() {
      this.isChartCollapse = !this.isChartCollapse
    },
    initDateValue() {
      // 获取当前日期
      const today = new Date()
      // prettier-ignore
      const todayZeroHour = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const beginTime = todayZeroHour.getTime() - 1000

      let startTime = new Date(beginTime)
      let endTime = new Date(beginTime + 24 * 60 * 60 * 1000)

      this.dateValue = [startTime, endTime]
    },
    filterUserList(filterValue) {
      this.filterValue = filterValue

      this.currentPage = 1
      this.allUserLoaded = false
      this.loading = true
      this.queryUserList().then(userList => {
        this.userList = userList
        this.loading = false
      })
    },
    onUserSelectFocus() {
      this.userId = ''
      this.filterUserList('')
    },
    handleUserListScroll() {
      if (this.allUserLoaded || this.filterValue) return
      this.currentPage++
      this.queryUserList().then(userList => {
        if (userList.length) {
          this.userList = [...this.userList, ...userList]
        } else {
          this.allUserLoaded = true
        }
      })
    },
    initUserList() {
      this.queryUserList().then(userList => {
        this.userList = userList
      })
    },
    timeTabClick(tabName) {
      this.currTimeTab = tabName

      // 获取当前日期
      const today = new Date()
      // prettier-ignore
      const todayZeroHour = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      let startTime = null
      let endTime = todayZeroHour.getTime() + 24 * 60 * 60 * 1000 - 1000
      if (tabName === 'day') {
        startTime = new Date(endTime - 24 * 60 * 60 * 1000)
      }

      if (tabName === 'week') {
        startTime = new Date(endTime - 7 * 24 * 60 * 60 * 1000)
      }

      if (tabName === 'month') {
        startTime = new Date(endTime - 30 * 24 * 60 * 60 * 1000)
      }

      endTime = new Date(endTime)
      this.dateValue = [startTime, endTime]
    },
    getTimeTabClassName(tabName) {
      let className = 'tab-item-box'
      if (tabName === this.currTimeTab) {
        className += ' tab-active'
      }
      return className
    },
    initStatisticsList() {
      this.isTableLoading = true
      this.queryStatisticsList().then(apiUsageDataList => {
        this.apiUsageDataList = apiUsageDataList
        this.isTableLoading = false
      })
    },
    search() {
      this.currPage = 1
      this.isTableLoading = true
      this.queryStatisticsList().then(apiUsageDataList => {
        this.apiUsageDataList = apiUsageDataList
        this.isTableLoading = false
      })
    },
    resetFilter() {
      this.routerName = ''

      this.userId = undefined
      this.filterValue = ''

      this.currTimeTab = 'day'
      this.initDateValue()
      this.currPage = 1
      this.queryStatisticsList().then(apiUsageDataList => {
        this.apiUsageDataList = apiUsageDataList
      })
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currPage = 1
      this.isTableLoading = true
      this.queryStatisticsList().then(apiUsageDataList => {
        this.apiUsageDataList = apiUsageDataList
        this.isTableLoading = false
      })
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.isTableLoading = true
      this.queryStatisticsList().then(apiUsageDataList => {
        this.apiUsageDataList = apiUsageDataList
        this.isTableLoading = false
      })
    },
    viewDetails(apiInfo) {
      this.apiInfo = apiInfo
      this.isDetailsDialogVisible = true
    },
    closeDetailsDialog() {
      this.apiInfo = {}
      this.isDetailsDialogVisible = false
    },
    initChart(echartOptions) {
      const color = [
        '#077ffe',
        '#09b66d',
        '#d83d6c',
        '#abbfe5',
        '#0015fc',
        '#ffcf5f',
        '#6742ff',
        '#ff7442',
        '#b60940',
        '#09b6a8',
        '#ffda07',
        '#66ff07',
        '#ffffff',
        '#fc0000',
        '#8c57ff',
        '#c6c6c6',
        '#00ffea',
        '#35a637',
        '#7e98ff',
        '#c599ff'
      ]
      if (!this.echartRef) {
        let option = {
          color: color,
          tooltip: {
            trigger: 'axis',
            triggerOn: 'click',
            formatter: params => this.formatTooltip(params),
            backgroundColor: 'var(--api-chart-tooltip-bgColor)',
            borderColor: 'var(--api-chart-tooltip-border-color)',
            textStyle: {
              align: 'left',
              color: 'var(--api-chart-tooltip-text-color)'
            },
            confine: true,
            enterable: true,
            extraCssText: 'max-height:240px;overflow-y:auto;'
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            icon: 'circle',
            left: '70%',
            right: 10, // 位置调整
            top: 0,
            textStyle: {
              // width: 300,
              color: this.chartsLegendTextColor,
              overflow: 'truncate',
              ellipsis: '...'
            },
            pageIconColor: this.chartsLegendPageIconColor,
            pageTextStyle: {
              color: this.chartsLegendTextColor
            },
            pageButtonItemGap: 0
          },
          grid: {
            top: '12%',
            left: '5%',
            right: '35%',
            bottom: '10%'
          },
          xAxis: {
            show: true,
            boundaryGap: true,
            name: '时间(小时)',
            nameLocation: 'end',
            nameGap: -5,
            nameTextStyle: {
              color: this.$theme.get().label === 'dark' ? '' : '',
              align: 'left',
              lineHeight: -25,
              verticalAlign: 'bottom'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              color: this.chartsAxisTextColor
            }
          },
          yAxis: {
            name: '访问次数(次)',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            nameTextStyle: {
              padding: 0,
              color: this.chartsAxisTextColor
            },
            axisLabel: {
              color: this.chartsAxisTextColor
            }
          }
        }

        option.legend.data = echartOptions.legendData
        option.xAxis.data = echartOptions.xAxisData
        option.series = echartOptions.series

        let echartDom = document.getElementById('echart')
        this.echartRef = echarts.init(echartDom)

        this.echartRef.setOption(option)
      } else {
        let option = this.echartRef.getOption()

        option.legend[0].data = echartOptions.legendData
        option.xAxis[0].data = echartOptions.xAxisData
        option.series = echartOptions.series

        this.echartRef.setOption(option, true)
      }
    },
    formatTooltip(params) {
      let str = ''
      params = params.filter(el => el.value)
      params.forEach((item, index) => {
        if (index === params.length - 1) {
          str += `<div style='display:flex;font-size:13px;line-height: 16px;'>`
        } else {
          str += `<div style='display:flex;margin-bottom: 10px;font-size:13px;line-height: 16px;'>`
        }
        if (this.currChartTab === 'api') {
          str += `<div style='flex-shrink: 0;display:inline-block;width:12px;height:12px;background:${item.color};border-radius:50%'></div>
                    <div style='margin-top:-2px;margin-left:5px'>接口名称：${item.seriesName}<br />访问次数: ${item.value}</div>
                  </div>`
        } else {
          str += `<div style='flex-shrink: 0;display:inline-block;width:12px;height:12px;background:${item.color};border-radius:50%'></div>
                    <div style='margin-top:-2px;margin-left:5px'>用户名称：${item.seriesName}<br />访问次数: ${item.value}</div>
                  </div>`
        }
      })
      return str
    },
    getEchartOptions(dates, items) {
      let legendData = items.map(item => item.key)
      let xAxisData = dates
      let allCount = []
      items.forEach(item => {
        allCount = [...item.values, ...allCount]
      })
      let maxValue = Math.max(...allCount)
      let barValue = Math.ceil(maxValue / 10) * 10
      let barData = []
      dates.forEach(item => {
        barData.push(barValue)
      })
      let series = []
      // let barSeries = {
      //   type: 'bar',
      //   tooltip: { show: false },
      //   data: barData,
      //   // barWidth: 80,
      //   barCategoryGap: 15,
      //   showBackground: true,
      //   backgroundStyle: {
      //     color: 'transparent',
      //     borderWidth: 1,
      //     borderColor: '#66676a'
      //   },
      //   areaStyle: { opacity: 0.2 },
      //   itemStyle: {
      //     color: 'transparent'
      //   }
      // }
      // series.push(barSeries)
      const color = [
        '#077ffe',
        '#09b66d',
        '#d83d6c',
        '#abbfe5',
        '#0015fc',
        '#ffcf5f',
        '#6742ff',
        '#ff7442',
        '#b60940',
        '#09b6a8',
        '#ffda07',
        '#66ff07',
        '#ffffff',
        '#fc0000',
        '#8c57ff',
        '#c6c6c6',
        '#00ffea',
        '#35a637',
        '#7e98ff',
        '#c599ff'
      ]
      items.forEach((item, index) => {
        let serie = {
          name: item.key,
          type: 'line',
          symbol: 'none',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: color[index % color.length] // 取预设颜色（循环使用）
                },
                {
                  offset: 1,
                  color: 'rgba(255,255,255,0)' // 结束颜色固定为白色
                }
              ]
            }
          },
          data: item.values
        }
        series.push(serie)
      })
      return { legendData, xAxisData, series }
    },
    queryTodayStatistics(statisticsType) {
      return new Promise(resolve => {
        let params = {
          hourRecall: 12,
          resultCount: 20,
          keys: []
        }
        if (statisticsType === 'api') {
          getTodayStatisticsByUrlService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let dates = data.dates
              dates = dates.map(item => {
                let str = item.slice(-2)
                return `${str}:00`
              })
              let items = data.items

              let echartOptions = this.getEchartOptions(dates, items)
              resolve(echartOptions)
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          getTodayStatisticsByUserService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let dates = data.dates
              dates = dates.map(item => {
                let str = item.slice(-2)
                return `${str}:00`
              })
              let items = data.items

              let echartOptions = this.getEchartOptions(dates, items)
              resolve(echartOptions)
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    queryUserList() {
      return new Promise(resolve => {
        let params = {
          maxResultCount: this.userListPageSize,
          skipCount: (this.currentPage - 1) * this.userListPageSize,
          searchType: 'surname',
          filter: this.filterValue
        }
        getUserNameList(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              let userList = data.items
              resolve(userList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    queryStatisticsList() {
      return new Promise(resolve => {
        let params = {
          userId: this.userId ? this.userId : undefined,
          url: this.routerName,
          maxResultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        if (this.dateValue.length) {
          params.beginTime = this.formatDate(this.dateValue[0])
          params.endTime = this.formatDate(this.dateValue[1])
        }
        getStatisticsListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let apiUsageDataList = data.items
            this.total = data.totalCount
            resolve(apiUsageDataList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatDate(dateTime) {
      // prettier-ignore
      const zeroHour = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

      let formatDateTime = zeroHour.getTime() + 24 * 60 * 60 * 1000 - 1000
      formatDateTime = formatTime(new Date(formatDateTime))
      return formatDateTime
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.api-usage-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 5px;
  background: transparent;

  .title-box {
    display: flex;
    align-items: center;

    .symbol {
      width: 4px;
      height: 20px;
      background: var(--base-primary-bgColor);
    }

    .title {
      margin-left: 10px;
      color: var(--page-title-color);
    }
  }

  .usage-chart-box {
    position: relative;
    padding: 15px;
    background: var(--page-bgColor);
    border-radius: 16px;
    // box-shadow: var(--base-bg-dark-color30);
    border: 1px solid var(--page-border-color);
    transition: all 0.3s;

    .tab-box {
      display: flex;
      margin: 20px 0px;

      .tab-item-box {
        margin-right: 10px;
        margin: 5px 15px;
        padding-bottom: 12px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        color: var(--tab-text-color);

        &:hover {
          color: var(--base-primary-bgColor);
        }
      }

      .active {
        color: var(--base-primary-bgColor);
        border-bottom: 3px solid var(--base-primary-bgColor);
      }
    }

    .echart-box {
      position: relative;
      height: 270px;

      .echarts-bg {
        position: absolute;
        width: 100%;
        height: 85%;
        z-index: 1;
        background-image: var(--api-chart-bgColor);
        background-size: 160px 160px;
      }

      .echart-content-box {
        position: relative;
        height: 100%;
        z-index: 2;
      }
    }

    .collapse-btn-box {
      position: absolute;
      left: 50%;
      margin-left: -20px;
      bottom: -10px;
      color: var(--api-chart-collapse-color);
      background: var(--api-chart-collapse-bgColor);
      border-radius: 50%;
      padding: 5px 10px;

      &:hover {
        .icon-box {
          color: var(--base-primary-bgColor);
        }
      }

      .icon-box {
        font-size: 14px;
        cursor: pointer;

        .el-icon {
          font-weight: 600;
        }
      }

      .is-collapse {
        transform: rotate(90deg);
      }
    }
  }

  .usage-table-box {
    z-index: 2;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-top: 15px;
    padding: 16px;
    padding-bottom: 0;
    border-radius: 16px;
    background: var(--page-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border: 1px solid var(--page-border-color);

    .operation-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 10px 0px;

      .filter-box {
        display: flex;

        .filter-item-box {
          display: flex;
          align-items: center;
          margin-right: 15px;

          .label-box {
            white-space: nowrap;
          }

          .common-select-box {
            text-align: left;

            .infinite-scroll-box {
              max-height: 240px;
              overflow-y: auto;
            }
          }

          .common-datepicker-box {
            width: 240px;

            :deep(.el-input__icon) {
              line-height: 24px;
            }
            .el-date-editor {
              width: 100%;
              .el-range-input {
                font-size: 14px;
                font-weight: 400;
              }
            }
          }

          .time-tab-box {
            display: flex;
            margin-left: 15px;

            .tab-item-box {
              white-space: nowrap;
              margin-right: 10px;
              padding: 5px 10px;
              font-size: 14px;
              font-weight: 400;
              border-radius: 8px;
              cursor: pointer;
              border: 1px solid var(--api-search-time-border-color);
              background-color: var(--api-search-time-bgColor);
              color: var(--api-search-time-text-color);

              &:hover {
                color: var(--base-primary-bgColor);
                border-color: var(--base-primary-bgColor);
              }
            }

            .tab-active {
              color: var(--base-primary-bgColor);
              border-color: var(--base-primary-bgColor);
              background-color: var(--base-bg-light-color24);
            }
          }
        }

        .userLabel {
          .primary-select {
            width: 210px;
          }
        }
      }
    }

    .common-button-box-search {
      display: flex;
    }

    .table-box {
      position: relative;
      flex-grow: 1;

      .common-table-box {
        position: absolute;
        width: 100%;
        height: 100%;

        .name-column-box {
          user-select: text;
        }
      }
    }

    .common-pagination-box {
    }
  }
}
</style>
